var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("a-modal", {
    attrs: {
      title: _vm.type == 1 ? _vm.$t("添加审核人") : _vm.$t("添加抄送人"),
      visible: _vm.dialogVisible,
      okText: _vm.$t("确认"),
      cancelText: _vm.$t("取消"),
      width: 1200
    },
    on: {
      ok: _vm.handleSure,
      cancel: () => {
        _vm.$emit("cancel");
      }
    }
  }, [_c("div", {
    staticClass: "box"
  }, [_c("div", {
    staticClass: "topBox"
  }, [_c("div", {
    staticClass: "leftBox"
  }, [_c("a-input", {
    staticStyle: {
      width: "100%"
    },
    attrs: {
      placeholder: _vm.$t("请输入") + _vm.$t("客户名称"),
      allowClear: ""
    },
    on: {
      change: _vm.customerNameChange
    },
    model: {
      value: _vm.customerName,
      callback: function ($$v) {
        _vm.customerName = $$v;
      },
      expression: "customerName"
    }
  }), _c("div", {
    staticClass: "itemBox"
  }, [_c("div", {
    style: 0 == _vm.tagLeftIndex ? "color:#1890ff" : "",
    on: {
      click: function ($event) {
        return _vm.tagLeftFun(0);
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("系统管理员")))]), _vm._l(_vm.customerList, function (item) {
    return _c("div", {
      key: item.id,
      style: _vm.customerObj.id == item.id ? "color:#1890ff" : "",
      on: {
        click: function ($event) {
          return _vm.customerChange(item);
        }
      }
    }, [_vm._v(" " + _vm._s(item.name) + " ")]);
  })], 2)], 1), _c("div", {
    staticClass: "rightBox"
  }, [_c("div", [_c("a-input", {
    staticStyle: {
      width: "180px"
    },
    attrs: {
      placeholder: _vm.$t("请输入") + _vm.$t("管理员名称"),
      allowClear: ""
    },
    model: {
      value: _vm.name,
      callback: function ($$v) {
        _vm.name = $$v;
      },
      expression: "name"
    }
  }), _c("a-button", {
    staticClass: "marginL15",
    attrs: {
      type: "primary",
      "html-type": "submit"
    },
    on: {
      click: _vm.searchFun
    }
  }, [_vm._v(_vm._s(_vm.$t("查询")))])], 1), _c("a-table", {
    staticClass: "marginT20",
    attrs: {
      bordered: "",
      columns: _vm.columns,
      "data-source": _vm.tableData,
      pagination: false,
      rowKey: "id",
      scroll: {
        y: 280
      }
    },
    scopedSlots: _vm._u([{
      key: "isSms",
      fn: function (text, record, index) {
        return [_c("a-switch", {
          attrs: {
            checked: _vm.checkedItem(text)
          },
          on: {
            click: function ($event) {
              return _vm.checkedFun(record, index);
            }
          }
        })];
      }
    }, {
      key: "checkbox",
      fn: function (text, record, index) {
        return [_c("a-checkbox", {
          attrs: {
            checked: _vm.checkedItem(text)
          },
          on: {
            click: function ($event) {
              return _vm.changeCheckbox(record, index);
            }
          }
        })];
      }
    }])
  }, _vm._l(_vm.columns, function (item, i) {
    var _item$slots, _item$slots2, _item$slots3;
    return _c("span", {
      key: i,
      attrs: {
        slot: (_item$slots = item.slots) === null || _item$slots === void 0 ? void 0 : _item$slots.title
      },
      slot: (_item$slots2 = item.slots) === null || _item$slots2 === void 0 ? void 0 : _item$slots2.title
    }, [_vm._v(_vm._s(_vm.$t((_item$slots3 = item.slots) === null || _item$slots3 === void 0 ? void 0 : _item$slots3.title)))]);
  }), 0)], 1)]), _c("div", {
    staticClass: "bottomBox"
  }, [_c("div", {
    staticStyle: {
      "margin-right": "8px"
    }
  }, [_vm._v(_vm._s(_vm.$t("已选择")) + ":")]), _vm._l(_vm.tagList, function (item) {
    return _c("a-tag", {
      key: item.id,
      attrs: {
        color: "blue",
        closable: ""
      },
      on: {
        close: () => _vm.handleClose(item)
      }
    }, [item.customerName ? _c("span", [_vm._v(_vm._s(item.customerName) + "/ ")]) : _vm._e(), _vm._v(_vm._s(item.nickName) + " ")]);
  })], 2)])]);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };